import { CollectionModel, customerApi, QueryTag } from '../api';
import { NameIdBasicModel } from './commonModels';

export const metadataApi = customerApi.injectEndpoints({
  endpoints: build => ({
    getVehicleGroups: build.query<NameIdBasicModel[], void>({
      query: () => 'api/metadata/vehicleGroups',
      transformResponse: (response: CollectionModel<NameIdBasicModel>) => response.items,
      providesTags: (result, error, arg) =>
        result ? [QueryTag.TenantCache, { type: QueryTag.Metadata, id: 'VEHICLEGROUPS' }] : [],
    }),
    getGeofenceAreas: build.query<NameIdBasicModel[], void>({
      query: () => 'api/metadata/geofenceAreas',
      transformResponse: (response: CollectionModel<NameIdBasicModel>) => response.items,
      providesTags: (result, error, arg) =>
        result ? [QueryTag.TenantCache, { type: QueryTag.Metadata, id: 'GEOFENCEAREAS' }] : [],
    }),
  }),
  overrideExisting: false,
});

export const { useGetVehicleGroupsQuery, useGetGeofenceAreasQuery } = metadataApi;
